import { Button } from "@mui/material";
import React from "react";

function CustomButton(props) {
  return (
    <Button
      sx={{
        color: "white",
        "&:hover": { color: "black", backgroundColor: "white" },
      }}
      {...props}
    ></Button>
  );
}

export default CustomButton;
